import localeAntd from 'antd/es/locale/de_DE'
import messages from './de.json'

export default {
  locale: 'de-DE',
  localeAntd,
  messages
}
